import {
  faBuilding,
  faCheck,
  faChevronRight,
  faGraduationCap,
  faUser
} from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Box, Divider, Grid, Typography } from "@mui/material"
import { styled } from "@mui/material/styles"
import LinkPaperBox from "components/LinkPaperBox"
import LoadingBox from "components/skeleton/LoadingBox/LoadingBox"
import LoadingTypography from "components/skeleton/LoadingTypography"
import { allRoutes } from "generated/routes"
import { getExaminationNameTranslation } from "pages/learning/pages/admin/pages/exams/pages/details/components/helpers/AttendeeStatus"
import { useTranslation } from "react-i18next"
import { NavLink } from "react-router-dom"

const StyledFontAwesomeIcon = styled(FontAwesomeIcon)(({ theme }) => ({
  color: theme.palette.grey[500]
}))

const ExamCard = ({ item, skeleton }) => {
  const { t } = useTranslation()
  if (skeleton) {
    item = {}
  }

  return (
    <LinkPaperBox>
      <NavLink to={allRoutes.SystemadminLearningExamDetails(item.id)}>
        <Grid container spacing={2}>
          <Grid item xs={10}>
            {skeleton ? (
              <LoadingTypography variant="h1" width="200px" />
            ) : (
              <Typography variant="h1">{getExaminationNameTranslation(item.name, t)}</Typography>
            )}
          </Grid>
          <Grid item xs={2}>
            <StyledFontAwesomeIcon icon={faChevronRight} size="2x" />
          </Grid>
          <Grid item xs={12}>
            <Divider />
          </Grid>

          <Grid item xs={10}>
            {skeleton ? (
              <div>
                <Box marginBottom={2}>
                  <LoadingBox width="100%" height="20px" />
                </Box>
                <Box marginBottom={2}>
                  <LoadingBox width="100%" height="20px" />
                </Box>
                <Box marginBottom={2}>
                  <LoadingBox width="100%" height="20px" />
                </Box>
                <Box marginBottom={2}>
                  <LoadingBox width="100%" height="20px" />
                </Box>
              </div>
            ) : (
              <table>
                <tr>
                  <td>
                    <Typography variant="bodyMedium">
                      <FontAwesomeIcon icon={faBuilding} />{" "}
                    </Typography>
                  </td>
                  <Typography variant="bodyMedium">
                    <td>
                      {t("global.customers", "Customers")}: {item.customerCount} {t("global.pc", "pcs")}
                    </td>
                  </Typography>
                </tr>
                <tr>
                  <td>
                    <Typography variant="bodyMedium">
                      <FontAwesomeIcon icon={faUser} />
                    </Typography>
                  </td>
                  <td>
                    <Typography variant="bodyMedium">
                      {t("learning.admin.titles.participant", "Participants")}: {item.userCount}{" "}
                      {t("global.pc", "pcs")}
                    </Typography>
                  </td>
                </tr>
                <tr>
                  <td>
                    <Typography variant="bodyMedium">
                      <FontAwesomeIcon icon={faGraduationCap} />
                    </Typography>
                  </td>
                  <td>
                    <Typography variant="bodyMedium">
                      {t("learning.admin.submitted_tests", "Submitted tests")}: {item.finishedTestsCount}{" "}
                      {t("global.pc", "pcs")}
                    </Typography>
                  </td>
                </tr>
                <tr>
                  <td>
                    <Typography variant="bodyMedium">
                      <FontAwesomeIcon icon={faCheck} />
                    </Typography>
                  </td>
                  <td>
                    <Typography variant="bodyMedium">
                      {t("learning.admin.approved_tests", "Approved tests")}: {item.passedTestCount}{" "}
                      {t("global.pc", "pcs")} (
                      {Math.round((item.passedTestCount / item.finishedTestsCount) * 1000000) / 10000} %)
                    </Typography>
                  </td>
                </tr>
              </table>
            )}
          </Grid>
        </Grid>
      </NavLink>
    </LinkPaperBox>
  )
}
export default ExamCard
